// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2cuNC","bigColWidth":"Table_bigColWidth__3Zj8_","biggerColWidth":"Table_biggerColWidth__32SIM","row":"Table_row__TIEE6","col":"Table_col__32eMH"};